module.exports = "/lucky-balls/img/bonus_yellow/check_infoBar/check_008.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/check_infoBar/check_008.png
// module id = 953
// module chunks = 0